/**
 * Created by senani on 1/2/19.
 */

import React from "react";
import './OrderHistory.css';
import CustomerOrderTable from "./CustomerOrderTable/CustomerOrderTable";
import {Link} from "react-router-dom";
import StencilCustomizedSize
    from "../../QuotationForm/StencilQuotationForm/StencilCustomizedSize/StencilCustomizedSize";
import AccountSideBar from "../../UserProfile/AccountSideBar/AccountSideBar";
import GoogleAds from "../../../Common/GoogleAds/GoogleAds";
import UserProfileNavBar from "../../UserProfile/UserProfileNavBar";
import ReactGA from "react-ga";
import {GOOGLE_ANALYTICS_CODE} from "../../../../configuration";
import MaintenanceMode from "./MaintenanceMode";


const OrderHistory = (props) => {
    ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
    ReactGA.pageview(window.location.pathname + window.location.search);

    return (
        <div className="quotation-content-new test-quotation-content">

            {/*<div>*/}
            {/*    <MaintenanceMode*/}
            {/*        heading={'ただいまメンテンナンス中です。'}*/}
            {/*        subHeading={'メンテンナンス期間：２０２３年２月４日～２０２３年２月１０日（予定)'}*/}
            {/*        messageLine1={'システムメンテナンスのため、上記日程の期間KITCUT PCBサイトを\n' +*/}
            {/*        '一時休止いたします。'}*/}
            {/*        messageLine2={'会員の皆様にはご迷惑をおかけしまして、誠に申し訳ございません。\n' +*/}
            {/*        '何卒、ご理解の程お願い申し上げます。'}*/}
            {/*    />*/}
            {/*</div>*/}
            <GoogleAds slot="696274611" />
            <div className="user-profile-container user-profile-container-responsive">
                <div className="row row-resp collapse-user-profile-div">
                    <UserProfileNavBar
                        itemName={'注文履歴'}
                        userId={props.userId}
                        userData={props.userData}
                    />
                </div>
                <div className="row">
                    <div className="col-md-2 right-padding-account-sidebar responsive-userAddress-table">
                        <AccountSideBar user={props.user}/>

                    </div>
                    <div className="col-md-10 mobile-responsive-padding">
                        <div className="order-history-content order-history-content-responsive no-padding no-margin">

                            <div className="order-history-div resp-order-history-div no-padding no-margin">
                                <CustomerOrderTable userData={props.userData}
                                                    userId={props.userId}
                                                    getCartItems={props.getCartItems}/>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
};

export default OrderHistory;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/OrderHistory.js